/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aware_Sweet_Insect_ZipInputs */

const fr_aware_sweet_insect_zip = /** @type {(inputs: Aware_Sweet_Insect_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une image`)
};

/**

* @param {Aware_Sweet_Insect_ZipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aware_sweet_insect_zip = /** @type {((inputs?: Aware_Sweet_Insect_ZipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aware_Sweet_Insect_ZipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aware_sweet_insect_zip(inputs)
});